<h2 mat-dialog-title class="rate-dialog__title">
    {{ ('modules.cases.evolutions.rate-evolution.title' | exp:'':'Calificar evaluación') }}
    <span *ngIf="titleDate"> — {{ titleDate }}</span>
    —
    <span class="ai-review-title rate-dialog__ai-title">
        <mat-icon class="ai-review-title__icon" svgIcon="ai-review"
            [style.width.px]="16" [style.height.px]="16"></mat-icon>
        <span class="ai-review-title__text">{{ ('modules.cases.evolutions.ai-review.badge' | exp:'':'Revisión IA') }}</span>
    </span>
</h2>

<mat-dialog-content [formGroup]="form" class="rate-dialog__content">
    <p class="subtitle-3 text-primary-darker mbs-2">
        {{ ('modules.cases.evolutions.rate-evolution.rate-this-evaluation' | exp:'':'Calificá esta evaluación') }}
    </p>

    <div class="rate-dialog__stars" role="group" aria-label="rating">
        <button type="button" mat-icon-button *ngFor="let s of [1,2,3,4,5]" (click)="setStar(s, $event)">
            <mat-icon class="rate-dialog__star"
                [class.rate-dialog__star--filled]="starValue >= s"
                [class.rate-dialog__star--half]="starValue >= s - 0.5 && starValue < s"
                [class.rate-dialog__star--empty]="starValue < s - 0.5">{{ starIcon(s) }}</mat-icon>
        </button>
        <span class="rate-dialog__stars-value text-secondary mat-small">{{ starValue }} / 5</span>
    </div>

    <div class="rate-dialog__preview mts-3">
        <span class="ai-review-title">
            <mat-icon class="ai-review-title__icon" svgIcon="ai-review"
                [style.width.px]="16" [style.height.px]="16"></mat-icon>
            <span class="ai-review-title__text">{{ ('modules.cases.evolutions.ai-review.badge' | exp:'':'Revisión IA') }}</span>
        </span>
        <p class="text-secondary mat-small mts-1">{{ previewText }}</p>
    </div>

    <label class="rate-dialog__notes-label subtitle-3 text-primary-darker" for="auditor-notes">
        {{ ('modules.cases.evolutions.rate-evolution.modifications-label' | exp:'':'Escribí las modificaciones correspondientes') }}
    </label>
    <textarea
        id="auditor-notes"
        class="rate-dialog__notes"
        rows="5"
        formControlName="auditorNotes"
        [attr.placeholder]="('modules.cases.evolutions.rate-evolution.modifications-placeholder' | exp:'':'Escribí las modificaciones correspondientes...')"
    ></textarea>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" type="button" (click)="cancel()">
        {{ ('common.cancel' | exp:'':'Cancelar') }}
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canSave" (click)="save()">
        {{ ('common.save' | exp:'':'Guardar') }}
    </button>
</mat-dialog-actions>
